import { Pipe, PipeTransform } from '@angular/core';
import { AreaTypesModel } from '@bo-client/shared/models/areaTypes';
import { AreaTypeEnum } from '@bo-client/activation-management/shared/models/commissioningModel';

// Todo: refactor areatypes
@Pipe({
  name: 'areaText'
})
export class AreaTextPipe implements PipeTransform {
  transform(value: string) {
    if (!value) {
      return '';
    }
    switch (value.toUpperCase()) {
      case AreaTypeEnum.POWER: {
        return 'Strom';
      }
      case AreaTypeEnum.GAS: {
        return 'Gas';
      }
      case 'HEAT': {
        return 'Fernwärme';
      }
      case 'LOCALHEAT': {
        return 'Nahwärme';
      }
      case AreaTypeEnum.WATER: {
        return 'Wasser';
      }
      case 'WASTEWATER': {
        return 'Abwasser';
      }
      case 'LWL': {
        return 'Leerrohr';
      }
      case 'LWLK': {
        return 'Glasfaser';
      }
      case AreaTypeEnum.DISTRICTHEAT: {
        return 'Fernwärme';
      }

      default: {
        return value;
      }
    }
  }
}

@Pipe({
  name: 'areaType'
})
export class AreaTypePipe implements PipeTransform {
  transform(value: number, areaTypes?: AreaTypesModel[]): string {
    return areaTypes?.find((areaType) => areaType.id === value)?.description || '';
  }
}
